export const REDIRECT_TO_PATH_URL_PARAM = "redirectToPathEncoded";
